import "./contact.css";
import { AiOutlineYoutube } from "react-icons/ai";
import { AiOutlineWhatsApp } from "react-icons/ai";
import { AiOutlineInstagram } from "react-icons/ai";

function Contact() {
  return (
    <div id="contact" className="container contact-container">
      <h1>Contact Me</h1>
      <div className="contact-links">
        <a
          href="https://wa.link/bywzv3"
          className="contact whatsapp"
          target={"blank"}
        >
          <AiOutlineWhatsApp className="icon" />
          <h2>
            whatsapp <span>01861557343</span>
          </h2>
        </a>
        <form  className="form-container">
          <input placeholder="Name" className="paddings " type="text" />
          <input placeholder="Email" className="paddings ml-2" type="email" />
          <textarea className="paddings" placeholder="Description" name="" id="" cols="51" rows="4"></textarea>
          <br />
          <input className="submit-button" type="submit" value="Submit" />
        </form>

        <a target='_blank' href="https://www.instagram.com/sktanjin/" rel="noreferrer" className="contact instagram">
          <AiOutlineInstagram className="icon" />
          <h2>
            instagram <span>skTanjin</span>
          </h2>
        </a>
      </div>
    </div>
  );
}

export default Contact;
